module.exports = __webpack_public_path__ + "img/wordpress.1fddce95.svg";